import React, { useEffect } from 'react'
import useForm from 'react-hook-form'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import ReactLoading from 'react-loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { withRouter } from 'react-router-dom'
import { faSuitcase, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Container
} from 'reactstrap'
import PropTypes from 'prop-types'
import { fetchSupplier, updateSupplier } from 'redux/actions/suppliers'
import SupplierForm from 'components/Suppliers/form'
import BackButton from 'components/BackButton'

const EditSupplier = ({ fetchSupplier, updateSupplier, form, loading, history, match }) => {
  const { register, reset, setError, handleSubmit, errors } = useForm()
  useEffect(() => {
    fetchSupplier(match.params.id)
  }, [fetchSupplier, match])

  useEffect(() => {
    reset(form)
  }, [form, reset])

  return (
    <Container className="pt-2 pt-md-5 pt-lg-6" fluid>
      <BackButton />
      <Row>
        <Col className="order-xl-1" xl="12">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col xs="12">
                  <h3 className="mb-0">
                    <FontAwesomeIcon icon={faSuitcase} className="mr-1"/> Editar Proveedor<br/>
                    <Button
                      tag={Link}
                      color="primary"
                      to="/admin/suppliers"
                      size="sm"
                      className="mt-2"
                    >
                      <FontAwesomeIcon icon={faAngleLeft} className="mr-2"/>
                      Regresar a Lista
                    </Button>
                    <Button
                      tag={Link}
                      color="primary"
                      to={`/admin/suppliers/${match.params.id}`}
                      size="sm"
                      className="mt-2"
                    >
                      <FontAwesomeIcon icon={faAngleLeft} className="mr-2"/>
                      Cancelar
                    </Button>
                  </h3>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              {!loading && (
                <SupplierForm
                  onSubmit={handleSubmit(params => updateSupplier({ ...params }, history, setError))}
                  history={history}
                  register={register}
                  errors={errors}
                />
              )}
              {loading && (
                <ReactLoading type="spinningBubbles" color="#000" height={30} width={30} className="mt-3" />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

const mapStateToProps = ({ suppliers: { form, loadingSupplier } }) => ({
  form,
  loading: loadingSupplier
})

const mapDispatchToProps = dispatch => ({
  fetchSupplier: id => dispatch(fetchSupplier(id)),
  updateSupplier: (values, history) => dispatch(updateSupplier(values, history)),
})

EditSupplier.propTypes = {
  form: PropTypes.shape({
    address: PropTypes.string,
    name: PropTypes.string,
  }),
  loading: PropTypes.bool,
  fetchSupplier: PropTypes.func.isRequired,
  updateSupplier: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    }).isRequired
  }).isRequired,
}

EditSupplier.defaultProps = {
  loading: false,
  form: {
    alias: '',
    fiscalName: '',
    rfc: '',
    turn: '',
    description: '',
    phone: '',
    email: '',
    clabe: '',
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditSupplier))
